import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { all_routes } from "../../../router/all_routes";
import { Link } from "react-router-dom";
// import { typesData } from "../../../common/json/typesList";
import CommonDatatable from "../../common/dataTable";
import LocationModal from "../../common/modal/locationModal";
import { CreateMasterData, DeleteMasterData, ListMasterData, ShowFullDateTime } from "../../../../functionsMaster";

function showMasterTitle(v = "") {
  let returnValue = v;
  returnValue = "Branch";
  return returnValue;
}

const CarMasterData = ({ tabeName = "branchLocation" }) => {
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [message, setMessage] = useState({ status: 0, message: "", editID: '0', loader: true, title: '', delete: '' });
  const defaultFormData = { title: "", status: 1, fuel: 0, distance: '' };
  const [formData, setFormData] = useState({
    ...defaultFormData, 
    title: '',
    email  : '',
    phone  : '',
    location : '',
    pinCode  : '',
    city  : '',
    status: 1,
    pickDropCharges: [],
  });

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value); // Update search state
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      render: (text: string) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
      sorter: (a: any, b: any) => a.NAME.length - b.NAME.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text = 1) => (
        <span
          className={`badge ${text === 1 ? "badge-success-transparent" : "badge-danger-transparent"} d-inline-flex align-items-center badge-sm`}
        >
          <i className="ti ti-point-filled me-1" />
          {text === 1 ? "Active" : "Inactive"}
        </span>
      ),
      sorter: (a: any, b: any) => a.STATUS.length - b.STATUS.length,
    },
    {
      title: "Last Updated",
      dataIndex: "updatedAt",
      render: (text: string) => (
        <h6 className="fw-medium">
          <Link to="#">{ShowFullDateTime(text)}</Link>
        </h6>
      ),
      sorter: (a: any, b: any) => a.NAME.length - b.NAME.length,
    },
    {
      title: "Action",
      dataIndex: "_id",
      render: (s = '0', record = { title: '', status: 0, distance: '', fuel: 0 }) => (
        <div>
          <Link
            to="/"
            data-bs-toggle="modal"
            data-bs-target="#add_type"
            className="btn btn-info"
            onClick={(e) => {
              e.preventDefault();
              setMessage({ ...message, status: 0, message: '', editID: s, loader: false });
              switch (tabeName) {
                case "test":
                  // returnValue = "Color";
                break;
                default:
                  setFormData({
                    ...formData,
                    ...record,
                    title: record.title,
                    status: record.status,
                    distance: record.distance,
                    fuel: record.fuel,
                });
                break;
              }
            }}
          >
            <i className="ti ti-edit me-2" />
          </Link>
        </div>
      ),
    },
  ];
  
  useEffect(() => {
    const fetchData = async () => {
    const temp = await ListMasterData(tabeName, {});
    // Do something with data, like setting it to state
    setData(temp.data);
  };

  fetchData();
}, [tabeName]);

  return (
    <>
      <div className="content me-4">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">{showMasterTitle(tabeName)}</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.adminDashboard}>Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {showMasterTitle(tabeName)}
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
            <div className="mb-2 me-2">
              <Link to="#" className="btn btn-white d-flex align-items-center">
                <i className="ti ti-printer me-2" />
                Print
              </Link>
            </div>
            <div className="me-2 mb-2">
              <div className="dropdown">
                <Link
                  to="#"
                  className="btn btn-dark d-inline-flex align-items-center"
                >
                  <i className="ti ti-upload me-1" />
                  Export
                </Link>
              </div>
            </div>
            <div className="mb-2">
              <Link
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#add_type"
                onClick={() => {
                  setFormData(defaultFormData);
                  setMessage({ ...message, status: 0, message: '', editID: '', loader: false, title: '' });
                }}
                className="btn btn-primary d-flex align-items-center"
              >
                <i className="ti ti-plus me-2" />
                Add New
              </Link>
            </div>
          </div>
        </div>
        {/* /Breadcrumb */}
        {/* Table Header */}
        <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-3">
          <div className="top-search me-2">
            <div className="top-search-group">
              <span className="input-icon">
                <i className="ti ti-search" />
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchValue} // Controlled input
                onChange={handleSearchChange} // Update search value
              />
            </div>
          </div>
        </div>
        {/* /Table Header */}
        {/* Custom Data Table */}
        {/* {console.log(data)} */}
        <CommonDatatable
          dataSource={data}
          columns={columns}
          searchValue={searchValue}
        />
        {/* Custom Data Table */}
      </div>

      {/* Add Type */}
      <form
        className="modal fade"
        id="add_type"
        onSubmit={async(e) => {
          e.preventDefault();
          setMessage({ ...message, ...message, loader: true });
          const temp =await CreateMasterData(tabeName, formData, message.editID);
          setMessage({ ...message, ...temp, editID: message.editID, loader: false, title: '' });
          
          // Close the modal
          if (temp.status === 1) {
            // Wait 1 second then close the modal
            setTimeout(() => {
              document.querySelector("#add_type .btn-close")?.click();
            }, 1786); // 1000ms = 1 second
            const temp = await ListMasterData(tabeName, {});
            // Do something with data, like setting it to state
            setData(temp.data);
        }
          
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">
                {message && message.editID && message.editID !== '0' ? "Update" : "Create"} {showMasterTitle(tabeName)}
              </h5>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x fs-16" />
              </button>
            </div>
            <div className="modal-body pb-1">
              <LocationModal setFormData={setFormData} formData={formData} />
              {message && message.message && message.message !== "" && (
                <div className={`alert alert-${message.status === 1 ? 'success' : 'danger'}`}>{message.message}</div>
              )}
              {message.loader && (<div className="text-center"><img src="/loader.gif" style={{ maxWidth: '45px' }} alt="" /></div>)}
            </div>

            <div className="modal-footer">
              <div className="d-flex justify-content-between align-items-center w-100">
                <div className="form-check form-check-md form-switch me-2">
                  <label className="form-check-label form-label mt-0 mb-0">
                    <input
                      className="form-check-input form-label me-2"
                      type="checkbox"
                      role="switch"
                      checked={formData.status === 1}
                      onChange={(e) => {
                        setFormData({ ...formData, status: e.target.checked ? 1 : 0});
                      }}
                    />
                    {/* {formData.status} */}
                    {formData.status === 1 ? "Active" : "Inactive"}
                  </label>
                </div>
                <div className="d-flex justify-content-center">
                  <button type="submit" className="btn btn-primary" disabled={message.loader}>
                    Submit
                  </button>
                </div>
              </div>
            </div>



          </div>
        </div>
      </form>
      {/* /Add Type */}

      {/* Delete Type */}
      <form
        className="modal fade"
        id="delete_type"
        onSubmit={async (e) => {
          e.preventDefault();
          if (message.delete === "Delete") {
            const temp =await DeleteMasterData(tabeName, message.editID);
            setMessage({ ...message, ...temp, editID: message.editID, loader: false, title: '' });
            // Close the modal
            if (temp.status === 1) {
              // Wait 1 second then close the modal
              setTimeout(() => {
                document.querySelector("#delete_type .closeBtn")?.click();
              }, 1786); // 1000ms = 1 second
              const temp = await ListMasterData(tabeName, {});
              // Do something with data, like setting it to state
              setData(temp.data);
            }
            } else {
              setMessage({ ...message, message: 'Please Confirm via Delete.', status: 0 });
            }
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <span className="avatar avatar-lg bg-transparent-danger rounded-circle text-danger mb-3">
                <i className="ti ti-trash-x fs-26" />
              </span>
              <h4 className="mb-1">Delete {showMasterTitle(tabeName)}: {message.title}</h4>
              <p className="mb-3">Are you sure you want to delete type?</p>
              <label>Enter Delete Below to confirm.</label>
              <input
                type="text"
                name="delete"
                className="form-control mt-2"
                value={message.delete}
                onChange={(e) => {
                  setMessage({ ...message, delete: e.target.value });
                }}
              />
              {message && message.message && message.message !== "" && (
                <div className={`alert mt-3 alert-${message.status === 1 ? 'success' : 'danger'}`}>{message.message}</div>
              )}
              <div className="d-flex justify-content-center">
                <Link
                  to="#"
                  className="btn closeBtn btn-light me-3"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <button type="submit" className="btn btn-primary">
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      {/* /Delete Brand */}
    </>
  );
};

CarMasterData.propTypes = {
  tabeName: PropTypes.string.isRequired, // or PropTypes.string if not required
};

export default CarMasterData;
